// České popisky klíčů z GET /ja: role (docs/08-autorizace.md §1 bod 3) a sekce (08 §2, názvy
// v menu prototypu). Jen pro zobrazení — co uživatel smí, rozhoduje server.

/** Popisek role podle klíče; neznámý klíč → undefined (účet bez role, 08 §1 bod 6). */
export const POPISEK_ROLE: Readonly<Record<string, string>> = {
  admin: 'Administrátor',
  jednatel: 'Jednatel',
  dispecer: 'Dispečer',
  koordinator: 'Koordinátor',
  obchodnik: 'Obchodník',
  vedouci_obchodu: 'Vedoucí obchodu',
  ridic: 'Řidič',
  skladnik: 'Skladník',
  mlynar: 'Mlynář',
  ucetni: 'Účetní',
  auditor: 'Auditor',
  vedouci_auditor: 'Vedoucí auditor',
  // 13. role — rozhodnutí 13. 9. 2026 večer (08 §1 bod 3); v prototypu neexistuje.
  administrativa: 'Administrativní pracovník',
};

export function popisekRole(klic: string | undefined): string | undefined {
  return klic ? POPISEK_ROLE[klic] : undefined;
}

/**
 * Název sekce v menu podle klíče — 1:1 s `navAll` prototypu (08 §2). Popisky závislé na roli
 * (`sklad_evidence` pro mlynáře, `iso` podle správcovství) řeší shell/menu.ts. Neznámý klíč → klíč.
 */
export const NAZEV_SEKCE: Readonly<Record<string, string>> = {
  home: 'Domů',
  kalendar: 'Kalendář',
  zakazky: 'Zakázky',
  audity: 'Audity',
  muj_den: 'Můj den',
  mapa_provozu: 'Mapa provozu',
  auta_na_ceste: 'Auta na cestě',
  svoz_pozadavky: 'Požadavky na svoz',
  sklad_evidence: 'Náš sklad',
  'sklad_evidence:evidence': 'Evidence a přeprava',
  'sklad_evidence:ilno': 'ILNO',
  vazeni: 'Vážení',
  celni_sprava: 'Celní správa',
  zakaznici: 'Zákazníci',
  odberatele: 'Odběratelé',
  kontakty: 'Kontakty',
  smlouvy: 'Smlouvy',
  ecosmlouvy: 'ECOsmlouvy',
  ucetnictvi: 'Účetnictví',
  dochazka: 'Docházka',
  ke_kontrole: 'Ke kontrole',
  pohledavky: 'Pohledávky',
  export_ucetni: 'Export do účetnictví',
  pokladny: 'Pokladny',
  poptavky: 'Poptávky',
  nabidky: 'Nabídky',
  moje_firmy: 'Moje firmy',
  pipeline: 'Pipeline',
  interakce: 'Aktivity',
  iso: 'Systém řízení (ISŘ)',
  vozidla: 'Vozidla',
  ceniky: 'Ceníky',
  sklad: 'Katalog položek',
  statistiky: 'Statistiky',
  interni_cenik: 'Interní ceník',
  vzory_dokumentu: 'Vzory dokumentů',
  archiv_dokumentu: 'Archiv dokumentů',
  zamestnanci: 'Zaměstnanci',
  'zamestnanci:zajemci': 'Zájemci o práci',
  nastaveni: 'Nastavení',
  hlaseni: 'Hlášení a připomínky',
  asistent: 'Asistent',
  pravidla_ai: 'Pravidla AI',
  znalostni_baze: 'Znalostní báze',
  k_vyrizeni: 'K vyřízení',
};

export function nazevSekce(klic: string): string {
  return NAZEV_SEKCE[klic] ?? klic;
}
